"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowerSystem = void 0;
const gotti_1 = require("gotti");
const Constants_1 = require("../../../Shared/Constants");
const types_1 = require("../../../Shared/types");
const Flower_1 = require("../../Assemblages/Flower");
const GameData_1 = require("../../../Shared/GameData");
const Utils_1 = require("../../../Shared/Utils");
class FlowerSystem extends gotti_1.ClientSystem {
    constructor() {
        super(Constants_1.SYSTEMS.FLOWER);
        this.numberOfBees = 0;
        this.numberOfTrees = 0;
        this.numberOfFullGrownFlowers = 0;
        this.timeTillNextFlower = 0;
        this.initializingGameState = false;
        this.refreshTotalCount = 0;
        // @ts-ignore
        this.holes = [];
        this.flowers = [];
        const handleCol = (colA, colB) => {
            const player = colA.gameObject.entity;
            const flower = colB.gameObject.entity;
            this.possiblePickupableFlowers.push(flower);
        };
        this.playerFlowCollisionPlugin = {
            type: 'collision',
            name: 'flower',
            tagAs: [Constants_1.COLLIDER_TAGS.in_front_of_client_player],
            tagBs: [Constants_1.COLLIDER_TAGS.flower],
            onCollisionStart: (colA, colB) => {
                if (!this.focusedFlower) {
                    this.focusedFlower = colB.gameObject.entity;
                }
            },
            onCollision: (colA, colB) => {
                if (!this.focusedFlower) {
                    this.focusedFlower = colB.gameObject.entity;
                }
            },
            onCollisionEnd: (colA, colB) => {
                if (this.focusedFlower === colB.gameObject.entity) {
                    this.focusedFlower = null;
                }
            },
        };
    }
    onClear() {
    }
    get growthHash() {
        return `${this.numberOfBees}_${this.numberOfTrees}_${this.numberOfFullGrownFlowers}`;
    }
    get growthRate() {
        return this.numberOfBees + this.numberOfTrees + this.numberOfFullGrownFlowers;
    }
    handleSpawnedBug(bug) {
        if (bug.bugType === types_1.BugTypes.BEE) {
            this.numberOfBees--;
        }
    }
    handleInitializedClientPlayer() {
        this.globals.clientPlayer.on('action', ({ actionName }) => {
            if (actionName === 'shovel') {
            }
        });
    }
    handleRemovedBug(bug) {
        if (bug.bugType === types_1.BugTypes.BEE) {
            this.numberOfBees++;
        }
    }
    isPlant(itemName) {
    }
    getSeedDataForFlower(type) {
        const seedType = type.replace('flower', 'seeds');
        if (!(seedType in GameData_1.PlatableGameData))
            throw new Error(`Could not find flower: ${type} from seed: ${seedType} in the lookup`);
        return GameData_1.PlatableGameData[seedType];
    }
    createFlowerEntity(type, plantedByPlayer, elapsedTimeAlive, x, y, uid) {
        const seedData = this.getSeedDataForFlower(type);
        const flowerData = {
            uid,
            name: type,
            x,
            y,
            state: {
                elapsedTimeAlive,
                plantedByPlayer,
            },
        };
        const flower = new Flower_1.Flower(flowerData);
        this.initializeEntity(flower);
        return flower;
    }
    initFlowerGameObject(flower, component) {
        const textureName = component.grownState === "flower" ? flower.flowerType : component.grownState;
        flower.gameObject = this.globals.tileWorld.addGameObject({
            texture: this.globals.gameTextures.items.placed[textureName],
            position: Object.assign({}, flower.getPosition()),
            layer: 1,
            colliders: [{
                    layer: 1,
                    dynamic: false,
                    shapeData: { x: 5, y: 8, w: 16, h: 15 },
                    tags: [Constants_1.COLLIDER_TAGS.flower]
                }]
        });
        flower.gameObject.entity = flower;
    }
    handleInitializedGameState(state) {
        this.initializingGameState = true;
        const islandData = state.levels.find(l => l.name === 'island').state;
        const flowers = islandData.items.filter(i => {
            return GameData_1.GlobalGameData.items[i.name].type === types_1.ItemTypes.FLOWER;
        });
        flowers.forEach(f => {
            this.createFlowerEntity(f.name, f.state.plantedByPlayer, f.state.elapsedTimeAlive, f.x, f.y, f.uid);
        });
        this.initializingGameState = false;
    }
    getFocusedFlower() { }
    plantSeed(seedName) {
        const flowerName = seedName.replace('seeds', 'flower');
        const focusedHole = this.$api.getFocusedHole();
        if (!focusedHole)
            return false;
        const { worldX: x, worldY: y } = focusedHole;
        this.createFlowerEntity(flowerName, true, 0, x - this.globals.gameTextures.items.placed.hole.width / 2, y - (this.globals.gameTextures.items.placed.hole.width + 2), this.$api.getUid());
        this.$api.removeHole(focusedHole);
        this.$api.removeItem(seedName, 1);
    }
    onLocalMessage(message) {
        switch (message.type) {
            case Constants_1.MESSAGES.FLOWER_FULLY_GROWN:
                this.numberOfFullGrownFlowers = this.$api.getNumberOfFullGrownFlowers();
                break;
            case Constants_1.MESSAGES.CLIENT_PLAYER_ENTITY_INITIALIZED:
                this.handleInitializedClientPlayer();
                break;
            case Constants_1.MESSAGES.REMOVED_TREE:
                this.numberOfTrees--;
                break;
            case Constants_1.MESSAGES.REMOVED_BUG:
                this.handleRemovedBug(message.data);
                break;
            case Constants_1.MESSAGES.SPAWNED_BUG:
                this.handleSpawnedBug(message.data);
                break;
            case Constants_1.MESSAGES.ADDED_HOLE:
                this.handleAddedHole(message.data.gameObject);
                break;
        }
    }
    handleAddedHole(hole) {
        //console.error('adding hole:"', hole, ' focused flower was', this.focusedFlower);
        if (!hole)
            return;
        const shapeData = hole.colliders[0].shapeData;
        if (this.focusedFlower && Utils_1.rectsAreColliding(shapeData, this.focusedFlower.gameObject.colliders[0].shapeData)) {
            this.removeFlower(this.focusedFlower);
        }
    }
    onInit() {
        this.addApi(this.getNumberOfFullGrownFlowers);
    }
    onStart() {
        this.globals.tileWorld.use(this.playerFlowCollisionPlugin);
        this.handleInitializedGameState(this.globals.gameStateData);
        this.addApi(this.plantSeed);
        this.globals.tileWorld.onBeforeMapDestroyed(mapName => {
            if (mapName === 'island') {
                this.flowers.forEach(f => {
                    if (f.flower.gameObject) {
                        delete f.flower.gameObject.entity;
                        f.flower.gameObject.removeFromMap();
                        delete f.flower.gameObject;
                    }
                });
            }
        });
        this.globals.tileWorld.onMapCreated(mapName => {
            if (mapName === 'island') {
                this.flowers.forEach(f => {
                    if (!f.flower.gameObject) {
                        this.initFlowerGameObject(f.flower, this.getSystemComponent(f.flower));
                    }
                });
            }
        });
    }
    removeFlower(flower) {
        const wasFullyGrownBeforeDestroy = flower.isFullyGrown;
        flower.gameObject.removeFromMap();
        const p = flower.getPosition();
        const flowerType = flower.flowerType;
        this.destroyEntity(flower);
        this.dispatchLocal({
            to: [Constants_1.SYSTEMS.GAME_STATE, Constants_1.SYSTEMS.BUG_SPAWN],
            type: Constants_1.MESSAGES.REMOVED_FLOWER,
            data: { uid: flower.id, type: flower.flowerType, wasFullyGrown: wasFullyGrownBeforeDestroy }
        });
        //        //console.error('flower fulyl grown:', flower.isFullyGrown, 'time alive:', flower.timeAlive, 'interval:', flower.getComponent(SYSTEMS.FLOWER).growTimeIntervals)
        if (wasFullyGrownBeforeDestroy) {
            const seedName = flowerType.replace('flower', 'seeds');
            const pedalName = flowerType.replace('flower', 'pedals');
            const randomSeedSpot1 = { x: Utils_1.getRandomNumber(p.x - 15, p.x + 5), y: Utils_1.getRandomNumber(p.y - 15, p.y + 15) };
            const randomSeedSpot2 = { x: Utils_1.getRandomNumber(p.x - 5, p.x + 15), y: Utils_1.getRandomNumber(p.y - 15, p.y + 15) };
            const randomPedalSpot = { x: Utils_1.getRandomNumber(p.x - 15, p.x + 15), y: Utils_1.getRandomNumber(p.y - 15, p.y + 15) };
            this.$api.dropItem(seedName, randomSeedSpot1.x, randomSeedSpot1.y);
            this.$api.dropItem(seedName, randomSeedSpot2.x, randomSeedSpot2.y);
            this.$api.dropItem(pedalName, randomPedalSpot.x, randomPedalSpot.y);
        }
    }
    onEntityRemovedComponent(entity, component) {
        if (entity.gameObject) {
            delete entity.gameObject.entity;
            delete entity.gameObject;
        }
        if (this.focusedFlower === entity) {
            this.focusedFlower = null;
        }
    }
    onEntityAddedComponent(entity, component) {
        const to = !this.initializingGameState ? [Constants_1.SYSTEMS.BUG_SPAWN] : [Constants_1.SYSTEMS.BUG_SPAWN, Constants_1.SYSTEMS.GAME_STATE];
        this.dispatchLocal({
            type: Constants_1.MESSAGES.NEW_FLOWER,
            data: entity,
            to
        });
        //console.error(';the current map was', this.globals.tileWorld.currentMap);
        if (this.globals.tileWorld.currentMap === "island") {
            this.initFlowerGameObject(entity, component);
        }
        if (entity.isFullyGrown) {
            this.dispatchLocal({
                type: Constants_1.MESSAGES.FLOWER_FULLY_GROWN,
                data: entity,
                to
            });
        }
        this.flowers.push({ flower: entity, component });
    }
    getNumberOfFullGrownFlowers() {
        let n = 0;
        for (let i = 0; i < this.flowers.length; i++) {
            if (this.flowers[i].flower.isFullyGrown) {
                n++;
            }
        }
        return n;
    }
    onPeerMessage(peerId, message) {
    }
    onServerMessage(message) {
    }
    get growMultiplier() {
        if (this.numberOfBees < 2) {
            return 1.5;
        }
        else if (this.numberOfBees < 5) {
            return 3.3;
        }
        else if (this.numberOfBees < 10) {
            return 5.3;
        }
        else if (this.numberOfBees < 20) {
            return 6.3;
        }
        else if (this.numberOfBees < 30) {
            return 8.2;
        }
        else if (this.numberOfBees < 40) {
            return 9;
        }
        else if (this.numberOfBees < 50) {
            return 10;
        }
        else if (this.numberOfBees < 70) {
            return 12;
        }
        else if (this.numberOfBees < 95) {
            return 15;
        }
        else if (this.numberOfBees < 100) {
            return 20;
        }
    }
    update(delta) {
        const growRate = delta * 75 * this.growMultiplier;
        this.flowers.forEach(({ flower, component }) => {
            if (component.updateTimeAlive(growRate) && flower.gameObject) {
                const textureName = component.grownState === "flower" ? flower.flowerType : component.grownState;
                flower.gameObject.texture = this.globals.gameTextures.items.placed[textureName];
            }
        });
    }
}
exports.FlowerSystem = FlowerSystem;
//# sourceMappingURL=module.js.map